import React, { FC, memo } from 'react';

import { CircularProgress, CircularProgressProps } from '@mui/material';

import { DEFAULT_LOADER_SIZE } from '@constants/common/ui.constants';

import useStyles from './styles.module';

type Props = {
  size?: number;
  className?: string;
  isCenter?: boolean;
} & CircularProgressProps;

const Loader: FC<Props> = ({
  isCenter = false,
  size = DEFAULT_LOADER_SIZE,
  className = '',
  ...props
}) => {
  const { classes, cx } = useStyles({ isCenter, size });

  return (
    <CircularProgress
      {...props}
      size={size}
      className={cx(classes.loader, className)}
    />
  );
};

export default memo(Loader);
